import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  deleteButton: {
    borderRadius: 17,
    float: 'right',
    marginRight: 20,
    marginTop: 5,
    padding: 5,
    height: 36,
    minHeight: 36,
    minWidth: 36,
    width: 36,

    '&.Mui-disabled': {
      opacity: 0.7,
    },
  },
}));
